// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1ciaQ","header":"ReportDetails_header__18llJ","title":"ReportDetails_title__2RFHs","left":"ReportDetails_left__3I_SY"};